var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "checkout-form" }, [
    _c(
      "div",
      {
        staticClass:
          "checkout-form__wrapper insicht insicht--fade-in insicht--fast",
      },
      [
        _c(
          "div",
          { staticClass: "checkout-form__container" },
          [
            _c("h1", {
              staticClass: "checkout-form__headline",
              domProps: { innerHTML: _vm._s(_vm.$t("checkout.title")) },
            }),
            _vm._v(" "),
            _c("Button", {
              staticClass:
                "checkout-form__back-to-shop checkout-form__back-to-shop--top",
              attrs: {
                level: "tertiary",
                type: "button",
                text: _vm.$t("checkout.continueShopping"),
                arrow: "",
                reverse: "",
                disabled: _vm.formLocked,
              },
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.backToShop.apply(null, arguments)
                },
              },
            }),
            _vm._v(" "),
            _vm.showPostdeliveryHint
              ? _c(
                  "div",
                  {
                    staticClass:
                      "checkout-form__block checkout-form__block--postdelivery",
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "checkout-form__login" },
                      [
                        _c(
                          "div",
                          { staticClass: "checkout-form__login-content" },
                          [
                            _c("h2", {
                              staticClass: "checkout-form__login-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.postdelivery.title")
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("i18n", {
                          staticClass: "checkout-form__login-actions",
                          attrs: { path: "checkout.login.actions", tag: "div" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "login",
                                fn: function () {
                                  return [
                                    _c("Button", {
                                      staticClass:
                                        "checkout-form__login-action",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t(
                                          "checkout.login.loginButton"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openLogin.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "register",
                                fn: function () {
                                  return [
                                    _c("Button", {
                                      staticClass:
                                        "checkout-form__login-action",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t(
                                          "checkout.login.registerButton"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openRegister.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2839886819
                          ),
                        }),
                      ],
                      1
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.isLoggedIn
              ? _c(
                  "div",
                  { staticClass: "checkout-form__block" },
                  [
                    _c(
                      "div",
                      { staticClass: "checkout-form__login" },
                      [
                        _c("SVGUser", {
                          staticClass: "checkout-form__login-icon",
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "checkout-form__login-content" },
                          [
                            _c("h2", {
                              staticClass: "checkout-form__login-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.login.title")
                                ),
                              },
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "checkout-form__login-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.login.text")
                                ),
                              },
                            }),
                          ]
                        ),
                        _vm._v(" "),
                        _c("i18n", {
                          staticClass: "checkout-form__login-actions",
                          attrs: { path: "checkout.login.actions", tag: "div" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "login",
                                fn: function () {
                                  return [
                                    _c("Button", {
                                      staticClass:
                                        "checkout-form__login-action",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t(
                                          "checkout.login.loginButton"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openLogin.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                              {
                                key: "register",
                                fn: function () {
                                  return [
                                    _c("Button", {
                                      staticClass:
                                        "checkout-form__login-action",
                                      attrs: {
                                        level: "tertiary",
                                        type: "button",
                                        text: _vm.$t(
                                          "checkout.login.registerButton"
                                        ),
                                      },
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          return _vm.openRegister.apply(
                                            null,
                                            arguments
                                          )
                                        },
                                      },
                                    }),
                                  ]
                                },
                                proxy: true,
                              },
                            ],
                            null,
                            false,
                            2839886819
                          ),
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("Button", {
                      staticClass: "checkout-form__login-guest",
                      attrs: {
                        level: "tertiary",
                        type: "button",
                        text: _vm.$t("checkout.login.continueAsGuest"),
                        arrow: "",
                        disabled: _vm.formLocked,
                      },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.scrollToForm.apply(null, arguments)
                        },
                      },
                    }),
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.notifyMessages, function (message, i) {
              return _c("GeneralMessage", {
                key: "message" + i,
                ref: "notificationMessages",
                refInFor: true,
                attrs: { message: message.message, type: message.type },
              })
            }),
            _vm._v(" "),
            _c("CheckoutCartButton", { attrs: { sticky: "" } }),
            _vm._v(" "),
            !_vm.addressSet
              ? [
                  _c("ValidationObserver", {
                    ref: "shippingAddressForm",
                    staticClass: "checkout-form__form-wrapper",
                    attrs: { tag: "form", novalidate: "" },
                    on: {
                      submit: function ($event) {
                        $event.preventDefault()
                        return _vm.onShippingAddress.apply(null, arguments)
                      },
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (ref) {
                            var invalid = ref.invalid
                            var errors = ref.errors
                            return [
                              _c(
                                "div",
                                { staticClass: "checkout-form__block" },
                                [
                                  _c("h2", {
                                    staticClass: "checkout-form__block-title",
                                    domProps: {
                                      innerHTML: _vm._s(_vm.addressTitle),
                                    },
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "form-row" },
                                    [
                                      _c("ValidationProvider", {
                                        ref: "email",
                                        staticClass: "form-row__wrapper",
                                        attrs: {
                                          name: "email",
                                          rules: "required|email",
                                          tag: "div",
                                          customMessages: {
                                            required: _vm.$t(
                                              "forms.errors.fieldEmpty"
                                            ),
                                            email: _vm.$t(
                                              "forms.errors.emailInvalid"
                                            ),
                                          },
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (ref) {
                                                var errors = ref.errors
                                                var invalid = ref.invalid
                                                var validated = ref.validated
                                                return [
                                                  _c("FormInput", {
                                                    attrs: {
                                                      type: "email",
                                                      placeholder:
                                                        _vm.$t(
                                                          "forms.labels.email"
                                                        ),
                                                      label:
                                                        _vm.$t(
                                                          "forms.labels.email"
                                                        ),
                                                      name: "email",
                                                      error: errors.length > 0,
                                                      readonly:
                                                        !!_vm.isLoggedIn,
                                                      "error-message":
                                                        errors[0],
                                                      hint: _vm.$t(
                                                        "checkout.emailHint"
                                                      ),
                                                      disabled: _vm.formLocked,
                                                      required: "",
                                                    },
                                                    model: {
                                                      value: _vm.form.email,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "email",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.email",
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          true
                                        ),
                                      }),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c("ValidationObserver", {
                                    ref: "shippingAddress",
                                    attrs: {
                                      tag: "section",
                                      vid: "shippingAddress",
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function (ref) {
                                            var invalid = ref.invalid
                                            return [
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c("ValidationProvider", {
                                                    ref: "shippingFirstname",
                                                    staticClass:
                                                      "form-row__wrapper",
                                                    attrs: {
                                                      name: "shippingFirstname",
                                                      rules: "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "forms.labels.firstname"
                                                                    ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.firstname"
                                                                  ),
                                                                  name: "firstname",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  "error-message":
                                                                    errors[0],
                                                                  disabled:
                                                                    _vm.formLocked,
                                                                  required: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .shippingAddress
                                                                      .firstName,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.form
                                                                          .shippingAddress,
                                                                        "firstName",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "form.shippingAddress.firstName",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    ref: "shippingLastname",
                                                    staticClass:
                                                      "form-row__wrapper",
                                                    attrs: {
                                                      name: "shippingLastname",
                                                      rules: "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "forms.labels.lastname"
                                                                    ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.lastname"
                                                                  ),
                                                                  name: "lastname",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  "error-message":
                                                                    errors[0],
                                                                  disabled:
                                                                    _vm.formLocked,
                                                                  required: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .shippingAddress
                                                                      .lastName,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.form
                                                                          .shippingAddress,
                                                                        "lastName",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "form.shippingAddress.lastName",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c("FormInput", {
                                                    attrs: {
                                                      type: "text",
                                                      placeholder: _vm.$t(
                                                        "forms.labels.company"
                                                      ),
                                                      label: _vm.$t(
                                                        "forms.labels.company"
                                                      ),
                                                      labelOption: _vm.$t(
                                                        "forms.labels.optional"
                                                      ),
                                                      name: "company",
                                                      required: false,
                                                      disabled: _vm.formLocked,
                                                    },
                                                    model: {
                                                      value:
                                                        _vm.form.shippingAddress
                                                          .company,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form
                                                            .shippingAddress,
                                                          "company",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.shippingAddress.company",
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c("ValidationObserver", {
                                                    ref: "shippingStreetNr",
                                                    staticClass:
                                                      "form-row__wrapper",
                                                    attrs: { tag: "div" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var validated =
                                                              ref.validated
                                                            var invalid =
                                                              ref.invalid
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-group",
                                                                },
                                                                [
                                                                  !_vm.themeValue(
                                                                    "THEME_REVERSE_STREET_NUMBER"
                                                                  )
                                                                    ? _c(
                                                                        "ValidationProvider",
                                                                        {
                                                                          ref: "shippingStreet",
                                                                          staticClass:
                                                                            "form-group__span--9",
                                                                          attrs:
                                                                            {
                                                                              name: "shippingStreet",
                                                                              rules:
                                                                                _vm.isDelivery
                                                                                  ? "required"
                                                                                  : "",
                                                                              tag: "div",
                                                                              customMessages:
                                                                                {
                                                                                  required:
                                                                                    _vm.$t(
                                                                                      "forms.errors.fieldEmpty"
                                                                                    ),
                                                                                },
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    var invalid =
                                                                                      ref.invalid
                                                                                    return [
                                                                                      _vm.hasFeature(
                                                                                        "FEATURE_ADDRESS_AUTOCOMPLETE"
                                                                                      )
                                                                                        ? _c(
                                                                                            "FormInputAutocomplete",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  type: "text",
                                                                                                  placeholder:
                                                                                                    _vm.$t(
                                                                                                      "forms.labels.street"
                                                                                                    ),
                                                                                                  label:
                                                                                                    _vm.$t(
                                                                                                      "forms.labels.street"
                                                                                                    ),
                                                                                                  labelOption:
                                                                                                    _vm.isDelivery
                                                                                                      ? ""
                                                                                                      : _vm.$t(
                                                                                                          "forms.labels.optional"
                                                                                                        ),
                                                                                                  name: "street",
                                                                                                  suggestions:
                                                                                                    _vm.addressSuggestions,
                                                                                                  error:
                                                                                                    errors.length >
                                                                                                    0,
                                                                                                  attributes:
                                                                                                    {
                                                                                                      "data-1p-ignore": true,
                                                                                                    },
                                                                                                  icon: "search",
                                                                                                  disabled:
                                                                                                    _vm.formLocked,
                                                                                                  required:
                                                                                                    _vm.isDelivery,
                                                                                                },
                                                                                              on: {
                                                                                                keydown:
                                                                                                  _vm.onAddressInput,
                                                                                                "suggestion:selected":
                                                                                                  _vm.onAddressSuggestion,
                                                                                              },
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    _vm
                                                                                                      .form
                                                                                                      .shippingAddress
                                                                                                      .street,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm
                                                                                                          .form
                                                                                                          .shippingAddress,
                                                                                                        "street",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                  expression:
                                                                                                    "form.shippingAddress.street",
                                                                                                },
                                                                                            }
                                                                                          )
                                                                                        : _c(
                                                                                            "FormInput",
                                                                                            {
                                                                                              attrs:
                                                                                                {
                                                                                                  type: "text",
                                                                                                  placeholder:
                                                                                                    _vm.$t(
                                                                                                      "forms.labels.street"
                                                                                                    ),
                                                                                                  label:
                                                                                                    _vm.$t(
                                                                                                      "forms.labels.street"
                                                                                                    ),
                                                                                                  labelOption:
                                                                                                    _vm.isDelivery
                                                                                                      ? ""
                                                                                                      : _vm.$t(
                                                                                                          "forms.labels.optional"
                                                                                                        ),
                                                                                                  name: "street",
                                                                                                  error:
                                                                                                    errors.length >
                                                                                                    0,
                                                                                                  disabled:
                                                                                                    _vm.formLocked,
                                                                                                  required:
                                                                                                    _vm.isDelivery,
                                                                                                },
                                                                                              model:
                                                                                                {
                                                                                                  value:
                                                                                                    _vm
                                                                                                      .form
                                                                                                      .shippingAddress
                                                                                                      .street,
                                                                                                  callback:
                                                                                                    function (
                                                                                                      $$v
                                                                                                    ) {
                                                                                                      _vm.$set(
                                                                                                        _vm
                                                                                                          .form
                                                                                                          .shippingAddress,
                                                                                                        "street",
                                                                                                        $$v
                                                                                                      )
                                                                                                    },
                                                                                                  expression:
                                                                                                    "form.shippingAddress.street",
                                                                                                },
                                                                                            }
                                                                                          ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "ValidationProvider",
                                                                    {
                                                                      ref: "shippingStreetNumber",
                                                                      staticClass:
                                                                        "form-group__span--3",
                                                                      attrs: {
                                                                        name: "shippingStreetNumber",
                                                                        rules:
                                                                          _vm.isDelivery
                                                                            ? "required"
                                                                            : "",
                                                                        tag: "div",
                                                                        customMessages:
                                                                          {
                                                                            required:
                                                                              _vm.$t(
                                                                                "forms.errors.fieldEmpty"
                                                                              ),
                                                                          },
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "default",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var errors =
                                                                                  ref.errors
                                                                                var invalid =
                                                                                  ref.invalid
                                                                                return [
                                                                                  _c(
                                                                                    "FormInput",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          type: "text",
                                                                                          placeholder:
                                                                                            _vm.$t(
                                                                                              "forms.labels.number"
                                                                                            ),
                                                                                          label:
                                                                                            _vm.$t(
                                                                                              "forms.labels.number"
                                                                                            ),
                                                                                          labelOption:
                                                                                            _vm.isDelivery
                                                                                              ? ""
                                                                                              : _vm.$t(
                                                                                                  "forms.labels.optional"
                                                                                                ),
                                                                                          name: "number",
                                                                                          error:
                                                                                            errors.length >
                                                                                            0,
                                                                                          disabled:
                                                                                            _vm.formLocked,
                                                                                          required:
                                                                                            _vm.isDelivery,
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .form
                                                                                              .shippingAddress
                                                                                              .streetNumber,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .form
                                                                                                  .shippingAddress,
                                                                                                "streetNumber",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "form.shippingAddress.streetNumber",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _vm.themeValue(
                                                                    "THEME_REVERSE_STREET_NUMBER"
                                                                  )
                                                                    ? _c(
                                                                        "ValidationProvider",
                                                                        {
                                                                          ref: "shippingStreet",
                                                                          staticClass:
                                                                            "form-group__span--9",
                                                                          attrs:
                                                                            {
                                                                              name: "shippingStreet",
                                                                              rules:
                                                                                _vm.isDelivery
                                                                                  ? "required"
                                                                                  : "",
                                                                              tag: "div",
                                                                              customMessages:
                                                                                {
                                                                                  required:
                                                                                    _vm.$t(
                                                                                      "forms.errors.fieldEmpty"
                                                                                    ),
                                                                                },
                                                                            },
                                                                          scopedSlots:
                                                                            _vm._u(
                                                                              [
                                                                                {
                                                                                  key: "default",
                                                                                  fn: function (
                                                                                    ref
                                                                                  ) {
                                                                                    var errors =
                                                                                      ref.errors
                                                                                    var invalid =
                                                                                      ref.invalid
                                                                                    return [
                                                                                      _c(
                                                                                        "FormInput",
                                                                                        {
                                                                                          attrs:
                                                                                            {
                                                                                              type: "text",
                                                                                              placeholder:
                                                                                                _vm.$t(
                                                                                                  "forms.labels.street"
                                                                                                ),
                                                                                              label:
                                                                                                _vm.$t(
                                                                                                  "forms.labels.street"
                                                                                                ),
                                                                                              labelOption:
                                                                                                _vm.isDelivery
                                                                                                  ? ""
                                                                                                  : _vm.$t(
                                                                                                      "forms.labels.optional"
                                                                                                    ),
                                                                                              name: "street",
                                                                                              error:
                                                                                                errors.length >
                                                                                                0,
                                                                                              disabled:
                                                                                                _vm.formLocked,
                                                                                              required:
                                                                                                _vm.isDelivery,
                                                                                            },
                                                                                          model:
                                                                                            {
                                                                                              value:
                                                                                                _vm
                                                                                                  .form
                                                                                                  .shippingAddress
                                                                                                  .street,
                                                                                              callback:
                                                                                                function (
                                                                                                  $$v
                                                                                                ) {
                                                                                                  _vm.$set(
                                                                                                    _vm
                                                                                                      .form
                                                                                                      .shippingAddress,
                                                                                                    "street",
                                                                                                    $$v
                                                                                                  )
                                                                                                },
                                                                                              expression:
                                                                                                "form.shippingAddress.street",
                                                                                            },
                                                                                        }
                                                                                      ),
                                                                                    ]
                                                                                  },
                                                                                },
                                                                              ],
                                                                              null,
                                                                              true
                                                                            ),
                                                                        }
                                                                      )
                                                                    : _vm._e(),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              validated
                                                                ? _c("div", {
                                                                    staticClass:
                                                                      "form-input__error | form-input-error form-group__span--12",
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          _vm.joinErrorMessage(
                                                                            errors
                                                                          )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                  _vm._v(" "),
                                                  _c("ValidationObserver", {
                                                    ref: "shippingZipCity",
                                                    staticClass:
                                                      "form-row__wrapper",
                                                    attrs: { tag: "div" },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var dirty =
                                                              ref.dirty
                                                            var validated =
                                                              ref.validated
                                                            var invalid =
                                                              ref.invalid
                                                            var errors =
                                                              ref.errors
                                                            return [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-group",
                                                                },
                                                                [
                                                                  _c(
                                                                    "ValidationProvider",
                                                                    {
                                                                      ref: "shippingZip",
                                                                      staticClass:
                                                                        "form-group__span--4 form-group__span--xxl-3",
                                                                      attrs: {
                                                                        name: "shippingZip",
                                                                        rules:
                                                                          _vm.isDelivery
                                                                            ? "required|zip"
                                                                            : "zip",
                                                                        tag: "div",
                                                                        customMessages:
                                                                          {
                                                                            required:
                                                                              _vm.$t(
                                                                                "forms.errors.fieldEmpty"
                                                                              ),
                                                                            zip: _vm.$t(
                                                                              "forms.errors.zip"
                                                                            ),
                                                                          },
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "default",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var errors =
                                                                                  ref.errors
                                                                                var invalid =
                                                                                  ref.invalid
                                                                                return [
                                                                                  _c(
                                                                                    "FormInputZip",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          placeholder:
                                                                                            _vm.$t(
                                                                                              "forms.labels.zip"
                                                                                            ),
                                                                                          label:
                                                                                            _vm.$t(
                                                                                              "forms.labels.zip"
                                                                                            ),
                                                                                          labelOption:
                                                                                            _vm.isDelivery
                                                                                              ? ""
                                                                                              : _vm.$t(
                                                                                                  "forms.labels.optional"
                                                                                                ),
                                                                                          name: "zip",
                                                                                          error:
                                                                                            errors.length >
                                                                                            0,
                                                                                          required:
                                                                                            _vm.isDelivery,
                                                                                          disabled:
                                                                                            _vm.formLocked,
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .form
                                                                                              .shippingAddress
                                                                                              .postcode,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .form
                                                                                                  .shippingAddress,
                                                                                                "postcode",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "form.shippingAddress.postcode",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  ),
                                                                  _vm._v(" "),
                                                                  _c(
                                                                    "ValidationProvider",
                                                                    {
                                                                      ref: "shippingCity",
                                                                      staticClass:
                                                                        "form-group__span--8 form-group__span--xxl-9",
                                                                      attrs: {
                                                                        name: "shippingCity",
                                                                        rules:
                                                                          _vm.isDelivery
                                                                            ? "required"
                                                                            : "",
                                                                        tag: "div",
                                                                        customMessages:
                                                                          {
                                                                            required:
                                                                              _vm.$t(
                                                                                "forms.errors.fieldEmpty"
                                                                              ),
                                                                          },
                                                                      },
                                                                      scopedSlots:
                                                                        _vm._u(
                                                                          [
                                                                            {
                                                                              key: "default",
                                                                              fn: function (
                                                                                ref
                                                                              ) {
                                                                                var errors =
                                                                                  ref.errors
                                                                                var invalid =
                                                                                  ref.invalid
                                                                                return [
                                                                                  _c(
                                                                                    "FormInput",
                                                                                    {
                                                                                      attrs:
                                                                                        {
                                                                                          type: "text",
                                                                                          placeholder:
                                                                                            _vm.$t(
                                                                                              "forms.labels.city"
                                                                                            ),
                                                                                          label:
                                                                                            _vm.$t(
                                                                                              "forms.labels.city"
                                                                                            ),
                                                                                          labelOption:
                                                                                            _vm.isDelivery
                                                                                              ? ""
                                                                                              : _vm.$t(
                                                                                                  "forms.labels.optional"
                                                                                                ),
                                                                                          name: "city",
                                                                                          error:
                                                                                            errors.length >
                                                                                            0,
                                                                                          required:
                                                                                            _vm.isDelivery,
                                                                                          disabled:
                                                                                            _vm.formLocked,
                                                                                        },
                                                                                      model:
                                                                                        {
                                                                                          value:
                                                                                            _vm
                                                                                              .form
                                                                                              .shippingAddress
                                                                                              .city,
                                                                                          callback:
                                                                                            function (
                                                                                              $$v
                                                                                            ) {
                                                                                              _vm.$set(
                                                                                                _vm
                                                                                                  .form
                                                                                                  .shippingAddress,
                                                                                                "city",
                                                                                                $$v
                                                                                              )
                                                                                            },
                                                                                          expression:
                                                                                            "form.shippingAddress.city",
                                                                                        },
                                                                                    }
                                                                                  ),
                                                                                ]
                                                                              },
                                                                            },
                                                                          ],
                                                                          null,
                                                                          true
                                                                        ),
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              invalid &&
                                                              (validated ||
                                                                dirty)
                                                                ? _c("div", {
                                                                    staticClass:
                                                                      "form-input__error | form-input-error form-group__span--12",
                                                                    domProps: {
                                                                      innerHTML:
                                                                        _vm._s(
                                                                          Object.values(
                                                                            errors
                                                                          )
                                                                            .filter(
                                                                              function (
                                                                                value
                                                                              ) {
                                                                                return !!value
                                                                                  .join(
                                                                                    ""
                                                                                  )
                                                                                  .trim()
                                                                              }
                                                                            )
                                                                            .join(
                                                                              " "
                                                                            )
                                                                        ),
                                                                    },
                                                                  })
                                                                : _vm._e(),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-row__wrapper",
                                                    },
                                                    [
                                                      _c("FormInput", {
                                                        attrs: {
                                                          type: "text",
                                                          placeholder: _vm.$t(
                                                            "forms.labels.addressDetails"
                                                          ),
                                                          label: _vm.$t(
                                                            "forms.labels.addressDetails"
                                                          ),
                                                          labelOption: _vm.$t(
                                                            "forms.labels.optional"
                                                          ),
                                                          name: "addressdetails",
                                                          required: false,
                                                          hint: _vm.$t(
                                                            "forms.labels.courierHint"
                                                          ),
                                                          disabled:
                                                            _vm.formLocked,
                                                        },
                                                        model: {
                                                          value:
                                                            _vm.form
                                                              .shippingAddress
                                                              .details,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              _vm.form
                                                                .shippingAddress,
                                                              "details",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "form.shippingAddress.details",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                  _vm._v(" "),
                                                  _c("ValidationProvider", {
                                                    ref: "shippingCountry",
                                                    staticClass:
                                                      "form-row__wrapper",
                                                    attrs: {
                                                      name: "shippingCountry",
                                                      rules: _vm.isDelivery
                                                        ? "required"
                                                        : "",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c(
                                                                "FormInputSelect",
                                                                {
                                                                  attrs: {
                                                                    options:
                                                                      _vm.countryOptions,
                                                                    label:
                                                                      _vm.$t(
                                                                        "forms.labels.country"
                                                                      ),
                                                                    name: "country",
                                                                    disabled:
                                                                      _vm.formLocked,
                                                                    required:
                                                                      _vm.isDelivery,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.form
                                                                        .shippingAddress
                                                                        .countryCode,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .shippingAddress,
                                                                          "countryCode",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "form.shippingAddress.countryCode",
                                                                  },
                                                                }
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c("ValidationProvider", {
                                                    ref: "shippingPhone",
                                                    staticClass:
                                                      "form-row__wrapper",
                                                    attrs: {
                                                      name: "shippingPhone",
                                                      rules:
                                                        "required|phone_int",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "forms.errors.fieldEmpty"
                                                        ),
                                                        phone_int:
                                                          _vm.$t(
                                                            "forms.errors.phone"
                                                          ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "tel",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "forms.labels.phone"
                                                                    ),
                                                                  label:
                                                                    _vm.$t(
                                                                      "forms.labels.phone"
                                                                    ),
                                                                  name: "phone",
                                                                  error:
                                                                    errors.length >
                                                                    0,
                                                                  "error-message":
                                                                    errors[0],
                                                                  hint: _vm.$t(
                                                                    "checkout.phoneHint"
                                                                  ),
                                                                  disabled:
                                                                    _vm.formLocked,
                                                                  required: "",
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .shippingAddress
                                                                      .phoneNumber,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.form
                                                                          .shippingAddress,
                                                                        "phoneNumber",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "form.shippingAddress.phoneNumber",
                                                                },
                                                              }),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("Button", {
                                attrs: {
                                  text: _vm.$t("checkout.continue"),
                                  level: "primary",
                                  type: "submit",
                                },
                              }),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      3764430104
                    ),
                  }),
                ]
              : [
                  _c(
                    "div",
                    { staticClass: "checkout-form__block" },
                    [
                      _c("h2", {
                        staticClass: "checkout-form__block-title",
                        domProps: { innerHTML: _vm._s(_vm.addressTitle) },
                      }),
                      _vm._v(" "),
                      _c("address", {
                        staticClass: "checkout-form__block-text",
                        domProps: {
                          innerHTML: _vm._s(_vm.formattedShippingAddress),
                        },
                      }),
                      _vm._v(" "),
                      _c("Button", {
                        attrs: {
                          level: "tertiary",
                          type: "button",
                          text: _vm.$t("checkout.changeShippingAddress"),
                          arrow: "",
                          disabled: _vm.formLocked,
                        },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.onShippingAddressEdit.apply(
                              null,
                              arguments
                            )
                          },
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  !_vm.deliverySet
                    ? [
                        _c("ValidationObserver", {
                          ref: "deliveryTimeForm",
                          staticClass: "checkout-form__form-wrapper",
                          attrs: { tag: "form", novalidate: "" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.onDeliveryTime()
                            },
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function (ref) {
                                  var invalid = ref.invalid
                                  var errors = ref.errors
                                  return [
                                    _vm.isDelivery
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "checkout-form__block",
                                          },
                                          [
                                            _c("h2", {
                                              staticClass:
                                                "checkout-form__block-title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "checkout.deliveryInfoTitle"
                                                  )
                                                ),
                                              },
                                            }),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "form-row" },
                                              [
                                                _c("div", {
                                                  staticClass:
                                                    "checkout-form__delivery-info",
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      _vm.$t(
                                                        "checkout.deliveryInfoText"
                                                      )
                                                    ),
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "checkout-form__block" },
                                      [
                                        _vm.deliveryMethods.length > 1
                                          ? [
                                              _c("h2", {
                                                staticClass:
                                                  "checkout-form__block-title",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "checkout.delivery.methodTitle"
                                                    )
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c("ValidationProvider", {
                                                    ref: "deliveryMethod",
                                                    attrs: {
                                                      name: "deliveryMethod",
                                                      rules: "required",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "checkout.delivery.methodError"
                                                        ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var errors =
                                                              ref.errors
                                                            var invalid =
                                                              ref.invalid
                                                            return [
                                                              _c(
                                                                "FormInputRadio",
                                                                {
                                                                  attrs: {
                                                                    name: "deliveryMethod",
                                                                    options:
                                                                      _vm.deliveryMethods,
                                                                    disabled:
                                                                      _vm.formLocked,
                                                                    error:
                                                                      errors.length >
                                                                      0,
                                                                    "error-message":
                                                                      errors[0],
                                                                    vertical:
                                                                      "",
                                                                    required:
                                                                      "",
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.deliveryMethod,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.deliveryMethod =
                                                                          $$v
                                                                      },
                                                                    expression:
                                                                      "deliveryMethod",
                                                                  },
                                                                }
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          : _vm._e(),
                                        _vm._v(" "),
                                        (_vm.deliveryMethods.length &&
                                          _vm.deliveryMethod) ||
                                        !_vm.deliveryMethods.length
                                          ? [
                                              _c("h2", {
                                                staticClass:
                                                  "checkout-form__block-title",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.timeTitle
                                                  ),
                                                },
                                              }),
                                              _vm._v(" "),
                                              _c(
                                                "div",
                                                { staticClass: "form-row" },
                                                [
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "form-row__wrapper",
                                                    },
                                                    [
                                                      _c("ValidationProvider", {
                                                        ref: "deliveryDate",
                                                        attrs: {
                                                          name: "deliveryDate",
                                                          rules: "required",
                                                          tag: "div",
                                                          customMessages: {
                                                            required: _vm.$t(
                                                              "checkout.errorDeliveryDate"
                                                            ),
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function (
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                var invalid =
                                                                  ref.invalid
                                                                return [
                                                                  _c(
                                                                    "FormInputDate",
                                                                    {
                                                                      attrs: {
                                                                        placeholder:
                                                                          _vm.$t(
                                                                            "forms.labels.date"
                                                                          ),
                                                                        label:
                                                                          _vm.$t(
                                                                            "forms.labels.date"
                                                                          ),
                                                                        initialValue:
                                                                          _vm.selectedDate,
                                                                        "min-date":
                                                                          _vm.deliveryMinDate,
                                                                        "max-date":
                                                                          _vm.deliveryMaxDate,
                                                                        isDateDisabled:
                                                                          _vm.isDateDisabled,
                                                                        disabled:
                                                                          _vm.formLocked,
                                                                        error:
                                                                          errors.length >
                                                                          0,
                                                                        "error-message":
                                                                          errors[0],
                                                                        required:
                                                                          "",
                                                                        "show-day":
                                                                          "",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.selectedDate,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.selectedDate =
                                                                              $$v
                                                                          },
                                                                        expression:
                                                                          "selectedDate",
                                                                      },
                                                                    }
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                      _vm._v(" "),
                                                      _c("ValidationProvider", {
                                                        ref: "deliveryTime",
                                                        attrs: {
                                                          name: "deliveryTime",
                                                          rules: "required",
                                                          tag: "div",
                                                          customMessages: {
                                                            required: _vm.$t(
                                                              "checkout.errorDeliveryTime"
                                                            ),
                                                          },
                                                        },
                                                        scopedSlots: _vm._u(
                                                          [
                                                            {
                                                              key: "default",
                                                              fn: function (
                                                                ref
                                                              ) {
                                                                var errors =
                                                                  ref.errors
                                                                var invalid =
                                                                  ref.invalid
                                                                return [
                                                                  _c(
                                                                    "TimePicker",
                                                                    {
                                                                      attrs: {
                                                                        times:
                                                                          _vm.deliveryTimes,
                                                                        label:
                                                                          _vm.$t(
                                                                            "forms.labels.time"
                                                                          ),
                                                                        disabled:
                                                                          _vm.formLocked,
                                                                        error:
                                                                          errors.length >
                                                                          0,
                                                                        "error-message":
                                                                          errors[0],
                                                                        "single-col":
                                                                          "",
                                                                        required:
                                                                          "",
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm.selectedTime,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.selectedTime =
                                                                              $$v
                                                                          },
                                                                        expression:
                                                                          "selectedTime",
                                                                      },
                                                                    }
                                                                  ),
                                                                ]
                                                              },
                                                            },
                                                          ],
                                                          null,
                                                          true
                                                        ),
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("Button", {
                                                attrs: {
                                                  text: _vm.$t(
                                                    "checkout.continue"
                                                  ),
                                                  level: "primary",
                                                  type: "submit",
                                                },
                                              }),
                                            ]
                                          : _vm._e(),
                                      ],
                                      2
                                    ),
                                  ]
                                },
                              },
                            ],
                            null,
                            false,
                            4284617623
                          ),
                        }),
                      ]
                    : [
                        _vm.isDelivery
                          ? _c("div", { staticClass: "checkout-form__block" }, [
                              _c("h2", {
                                staticClass: "checkout-form__block-title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("checkout.deliveryInfoTitle")
                                  ),
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "form-row" }, [
                                _c("div", {
                                  staticClass: "checkout-form__delivery-info",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.$t("checkout.deliveryInfoText")
                                    ),
                                  },
                                }),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "checkout-form__block" },
                          [
                            _c("h2", {
                              staticClass: "checkout-form__block-title",
                              domProps: { innerHTML: _vm._s(_vm.timeTitle) },
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "checkout-form__time" },
                              [
                                _c("SVGClock", {
                                  staticClass: "checkout-form__time-icon",
                                }),
                                _vm._v(" "),
                                _c("span", {
                                  staticClass: "checkout-form__time-text",
                                  domProps: {
                                    innerHTML: _vm._s(_vm.deliveryTimeEnhanced),
                                  },
                                }),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("Button", {
                              staticClass: "checkout-form__time-edit",
                              attrs: {
                                type: "button",
                                level: "tertiary",
                                arrow: "",
                                text: _vm.timeEditLabel,
                                disabled: _vm.formLocked,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.onDeliveryTimeEdit.apply(
                                    null,
                                    arguments
                                  )
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("ValidationObserver", {
                          ref: "form",
                          staticClass: "checkout-form__form-wrapper",
                          attrs: { tag: "form", novalidate: "" },
                          on: {
                            submit: function ($event) {
                              $event.preventDefault()
                              return _vm.onDeliveryTime.apply(null, arguments)
                            },
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function (ref) {
                                var invalid = ref.invalid
                                var errors = ref.errors
                                return [
                                  _c(
                                    "div",
                                    { staticClass: "checkout-form__block" },
                                    [
                                      _c("h2", {
                                        staticClass:
                                          "checkout-form__block-title",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("checkout.chopsticksTitle")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "FormInputCheckbox",
                                        {
                                          attrs: {
                                            name: "chopsticks",
                                            value: "chopsticks",
                                            immediate: "",
                                            disabled: _vm.formLocked,
                                          },
                                          model: {
                                            value: _vm.form.chopsticks,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.form,
                                                "chopsticks",
                                                $$v
                                              )
                                            },
                                            expression: "form.chopsticks",
                                          },
                                        },
                                        [
                                          _c("span", {
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t(
                                                  "checkout.chopsticksLabel"
                                                )
                                              ),
                                            },
                                          }),
                                        ]
                                      ),
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "checkout-form__block" },
                                    [
                                      _c("h2", {
                                        staticClass:
                                          "checkout-form__block-title",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("checkout.notesTitle")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "form-row" },
                                        [
                                          _c("FormInputTextarea", {
                                            attrs: {
                                              placeholder:
                                                _vm.$t("forms.labels.notes"),
                                              label:
                                                _vm.$t("forms.labels.notes"),
                                              disabled: _vm.formLocked,
                                            },
                                            model: {
                                              value: _vm.form.notes,
                                              callback: function ($$v) {
                                                _vm.$set(_vm.form, "notes", $$v)
                                              },
                                              expression: "form.notes",
                                            },
                                          }),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _vm.checkoutPayments.length
                                    ? _c(
                                        "div",
                                        { staticClass: "checkout-form__block" },
                                        [
                                          _c("h2", {
                                            staticClass:
                                              "checkout-form__block-title",
                                            domProps: {
                                              innerHTML: _vm._s(
                                                _vm.$t("checkout.paymentTitle")
                                              ),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "form-row" },
                                            [
                                              _vm.checkoutPayments.length
                                                ? _c("ValidationProvider", {
                                                    staticClass:
                                                      "form-row__wrapper",
                                                    attrs: {
                                                      rules: "required",
                                                      name: "paymentCode",
                                                      tag: "div",
                                                      customMessages: {
                                                        required: _vm.$t(
                                                          "checkout.errorPaymentMethod"
                                                        ),
                                                      },
                                                    },
                                                    scopedSlots: _vm._u(
                                                      [
                                                        {
                                                          key: "default",
                                                          fn: function (ref) {
                                                            var invalid =
                                                              ref.invalid
                                                            var errors =
                                                              ref.errors
                                                            var validated =
                                                              ref.validated
                                                            return [
                                                              _c(
                                                                "FormInputPayment",
                                                                {
                                                                  attrs: {
                                                                    methods:
                                                                      _vm.checkoutPayments,
                                                                    error:
                                                                      errors.length >
                                                                      0,
                                                                    "error-message":
                                                                      errors[0],
                                                                    disabled:
                                                                      _vm.formLocked,
                                                                  },
                                                                  on: {
                                                                    input:
                                                                      _vm.onPaymentChanged,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.form
                                                                        .paymentCode,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm.form,
                                                                          "paymentCode",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "form.paymentCode",
                                                                  },
                                                                }
                                                              ),
                                                            ]
                                                          },
                                                        },
                                                      ],
                                                      null,
                                                      true
                                                    ),
                                                  })
                                                : _vm._e(),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showBirthday
                                    ? _c(
                                        "div",
                                        { staticClass: "checkout-form__block" },
                                        [
                                          _c(
                                            "div",
                                            { staticClass: "form-row" },
                                            [
                                              _c("ValidationProvider", {
                                                attrs: {
                                                  name: "birthday",
                                                  rules: "required",
                                                  tag: "div",
                                                  customMessages: {
                                                    required: _vm.$t(
                                                      "forms.errors.fieldEmpty"
                                                    ),
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var errors = ref.errors
                                                        var invalid =
                                                          ref.invalid
                                                        var validated =
                                                          ref.validated
                                                        return [
                                                          _c("h2", {
                                                            staticClass:
                                                              "checkout-form__block-subtitle",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "checkout.birthdayTitle"
                                                                )
                                                              ),
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("div", {
                                                            staticClass:
                                                              "checkout-form__block-text",
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "checkout.birthdayText"
                                                                )
                                                              ),
                                                            },
                                                          }),
                                                          _vm._v(" "),
                                                          _c("FormInputDate", {
                                                            attrs: {
                                                              placeholder:
                                                                _vm.$t(
                                                                  "forms.labels.birthday"
                                                                ),
                                                              label: _vm.$t(
                                                                "forms.labels.birthday"
                                                              ),
                                                              "max-date":
                                                                "today",
                                                              error:
                                                                errors.length >
                                                                0,
                                                              "error-message":
                                                                errors[0],
                                                              disabled:
                                                                _vm.formLocked,
                                                              required: "",
                                                            },
                                                            model: {
                                                              value:
                                                                _vm.form
                                                                  .birthday,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    _vm.form,
                                                                    "birthday",
                                                                    $$v
                                                                  )
                                                                },
                                                              expression:
                                                                "form.birthday",
                                                            },
                                                          }),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              }),
                                            ],
                                            1
                                          ),
                                        ]
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showBillingAddress
                                    ? _c(
                                        "div",
                                        { staticClass: "checkout-form__block" },
                                        [
                                          _c("h2", {
                                            staticClass:
                                              "checkout-form__block-title",
                                            domProps: {
                                              innerHTML:
                                                _vm._s("Rechnungsadresse"),
                                            },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "FormInputCheckbox",
                                            {
                                              attrs: {
                                                name: "billingAddressIdentical",
                                                value:
                                                  "billingAddressIdentical",
                                                disabled: _vm.formLocked,
                                                immediate: "",
                                              },
                                              model: {
                                                value:
                                                  _vm.form
                                                    .billingAddressIdentical,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "billingAddressIdentical",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "form.billingAddressIdentical",
                                              },
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    "Rechnungsadresse ist gleich wie Lieferadresse"
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          !_vm.form.billingAddressIdentical
                                            ? _c("ValidationObserver", {
                                                ref: "billingAddress",
                                                attrs: {
                                                  tag: "section",
                                                  vid: "billingAddress",
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var invalid =
                                                          ref.invalid
                                                        return [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-row",
                                                            },
                                                            [
                                                              _c(
                                                                "FormInputSelect",
                                                                {
                                                                  attrs: {
                                                                    options:
                                                                      _vm.genders,
                                                                    name: "gender",
                                                                    label:
                                                                      _vm.$t(
                                                                        "forms.labels.gender"
                                                                      ),
                                                                    labelOption:
                                                                      _vm.$t(
                                                                        "forms.labels.optional"
                                                                      ),
                                                                    disabled:
                                                                      _vm.formLocked,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.form
                                                                        .billingAddress
                                                                        .gender,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .billingAddress,
                                                                          "gender",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "form.billingAddress.gender",
                                                                  },
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-row",
                                                            },
                                                            [
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  staticClass:
                                                                    "form-row__wrapper",
                                                                  attrs: {
                                                                    name: "billingFirstname",
                                                                    rules:
                                                                      "required",
                                                                    tag: "div",
                                                                    customMessages:
                                                                      {
                                                                        required:
                                                                          _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          ),
                                                                      },
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function (
                                                                            ref
                                                                          ) {
                                                                            var errors =
                                                                              ref.errors
                                                                            var invalid =
                                                                              ref.invalid
                                                                            var validated =
                                                                              ref.validated
                                                                            return [
                                                                              _c(
                                                                                "FormInput",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "text",
                                                                                      placeholder:
                                                                                        _vm.$t(
                                                                                          "forms.labels.firstname"
                                                                                        ),
                                                                                      label:
                                                                                        _vm.$t(
                                                                                          "forms.labels.firstname"
                                                                                        ),
                                                                                      name: "firstname",
                                                                                      error:
                                                                                        errors.length >
                                                                                        0,
                                                                                      "error-message":
                                                                                        errors[0],
                                                                                      disabled:
                                                                                        _vm.formLocked,
                                                                                      required:
                                                                                        "",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .firstName,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .form
                                                                                              .billingAddress,
                                                                                            "firstName",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "form.billingAddress.firstName",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  staticClass:
                                                                    "form-row__wrapper",
                                                                  attrs: {
                                                                    name: "billingLastname",
                                                                    rules:
                                                                      "required",
                                                                    tag: "div",
                                                                    customMessages:
                                                                      {
                                                                        required:
                                                                          _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          ),
                                                                      },
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function (
                                                                            ref
                                                                          ) {
                                                                            var errors =
                                                                              ref.errors
                                                                            var invalid =
                                                                              ref.invalid
                                                                            var validated =
                                                                              ref.validated
                                                                            return [
                                                                              _c(
                                                                                "FormInput",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "text",
                                                                                      placeholder:
                                                                                        _vm.$t(
                                                                                          "forms.labels.lastname"
                                                                                        ),
                                                                                      label:
                                                                                        _vm.$t(
                                                                                          "forms.labels.lastname"
                                                                                        ),
                                                                                      name: "lastname",
                                                                                      error:
                                                                                        errors.length >
                                                                                        0,
                                                                                      "error-message":
                                                                                        errors[0],
                                                                                      disabled:
                                                                                        _vm.formLocked,
                                                                                      required:
                                                                                        "",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .lastName,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .form
                                                                                              .billingAddress,
                                                                                            "lastName",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "form.billingAddress.lastName",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-row",
                                                            },
                                                            [
                                                              _c("FormInput", {
                                                                attrs: {
                                                                  type: "text",
                                                                  placeholder:
                                                                    _vm.$t(
                                                                      "forms.labels.company"
                                                                    ),
                                                                  label: _vm.$t(
                                                                    "forms.labels.company"
                                                                  ),
                                                                  labelOption:
                                                                    _vm.$t(
                                                                      "forms.labels.optional"
                                                                    ),
                                                                  name: "company",
                                                                  required: false,
                                                                  disabled:
                                                                    _vm.formLocked,
                                                                },
                                                                model: {
                                                                  value:
                                                                    _vm.form
                                                                      .billingAddress
                                                                      .company,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        _vm.form
                                                                          .billingAddress,
                                                                        "company",
                                                                        $$v
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "form.billingAddress.company",
                                                                },
                                                              }),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-row",
                                                            },
                                                            [
                                                              _c(
                                                                "ValidationObserver",
                                                                {
                                                                  ref: "billingStreetNr",
                                                                  staticClass:
                                                                    "form-row__wrapper",
                                                                  attrs: {
                                                                    tag: "div",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function (
                                                                            ref
                                                                          ) {
                                                                            var validated =
                                                                              ref.validated
                                                                            var invalid =
                                                                              ref.invalid
                                                                            var errors =
                                                                              ref.errors
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "form-group",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "ValidationProvider",
                                                                                    {
                                                                                      staticClass:
                                                                                        "form-group__span--9",
                                                                                      attrs:
                                                                                        {
                                                                                          name: "billingStreet",
                                                                                          rules:
                                                                                            "required",
                                                                                          tag: "div",
                                                                                          customMessages:
                                                                                            {
                                                                                              required:
                                                                                                _vm.$t(
                                                                                                  "forms.errors.fieldEmpty"
                                                                                                ),
                                                                                            },
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "default",
                                                                                              fn: function (
                                                                                                ref
                                                                                              ) {
                                                                                                var errors =
                                                                                                  ref.errors
                                                                                                var invalid =
                                                                                                  ref.invalid
                                                                                                return [
                                                                                                  _c(
                                                                                                    "FormInput",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          type: "text",
                                                                                                          placeholder:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.street"
                                                                                                            ),
                                                                                                          label:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.street"
                                                                                                            ),
                                                                                                          name: "street",
                                                                                                          error:
                                                                                                            errors.length >
                                                                                                            0,
                                                                                                          disabled:
                                                                                                            _vm.formLocked,
                                                                                                          required:
                                                                                                            "",
                                                                                                        },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            _vm
                                                                                                              .form
                                                                                                              .billingAddress
                                                                                                              .street,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                _vm
                                                                                                                  .form
                                                                                                                  .billingAddress,
                                                                                                                "street",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "form.billingAddress.street",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "ValidationProvider",
                                                                                    {
                                                                                      staticClass:
                                                                                        "form-group__span--3",
                                                                                      attrs:
                                                                                        {
                                                                                          name: "billingStreetNumber",
                                                                                          rules:
                                                                                            "required",
                                                                                          tag: "div",
                                                                                          customMessages:
                                                                                            {
                                                                                              required:
                                                                                                _vm.$t(
                                                                                                  "forms.errors.fieldEmpty"
                                                                                                ),
                                                                                            },
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "default",
                                                                                              fn: function (
                                                                                                ref
                                                                                              ) {
                                                                                                var errors =
                                                                                                  ref.errors
                                                                                                var invalid =
                                                                                                  ref.invalid
                                                                                                return [
                                                                                                  _c(
                                                                                                    "FormInput",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          type: "text",
                                                                                                          placeholder:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.number"
                                                                                                            ),
                                                                                                          label:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.number"
                                                                                                            ),
                                                                                                          name: "number",
                                                                                                          error:
                                                                                                            errors.length >
                                                                                                            0,
                                                                                                          disabled:
                                                                                                            _vm.formLocked,
                                                                                                          required:
                                                                                                            "",
                                                                                                        },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            _vm
                                                                                                              .form
                                                                                                              .billingAddress
                                                                                                              .streetNumber,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                _vm
                                                                                                                  .form
                                                                                                                  .billingAddress,
                                                                                                                "streetNumber",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "form.billingAddress.streetNumber",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              invalid &&
                                                                              validated
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "form-input__error | form-input-error form-group__span--12",
                                                                                      domProps:
                                                                                        {
                                                                                          innerHTML:
                                                                                            _vm._s(
                                                                                              Object.values(
                                                                                                errors
                                                                                              )
                                                                                                .filter(
                                                                                                  function (
                                                                                                    value
                                                                                                  ) {
                                                                                                    return !!value
                                                                                                      .join(
                                                                                                        ""
                                                                                                      )
                                                                                                      .trim()
                                                                                                  }
                                                                                                )
                                                                                                .join(
                                                                                                  " "
                                                                                                )
                                                                                            ),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "ValidationObserver",
                                                                {
                                                                  ref: "billingZipCity",
                                                                  staticClass:
                                                                    "form-row__wrapper",
                                                                  attrs: {
                                                                    tag: "div",
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function (
                                                                            ref
                                                                          ) {
                                                                            var dirty =
                                                                              ref.dirty
                                                                            var validated =
                                                                              ref.validated
                                                                            var invalid =
                                                                              ref.invalid
                                                                            var errors =
                                                                              ref.errors
                                                                            return [
                                                                              _c(
                                                                                "div",
                                                                                {
                                                                                  staticClass:
                                                                                    "form-group",
                                                                                },
                                                                                [
                                                                                  _c(
                                                                                    "ValidationProvider",
                                                                                    {
                                                                                      staticClass:
                                                                                        "form-group__span--4 form-group__span--xxl-3",
                                                                                      attrs:
                                                                                        {
                                                                                          name: "billingZip",
                                                                                          rules:
                                                                                            "required|zip",
                                                                                          tag: "div",
                                                                                          customMessages:
                                                                                            {
                                                                                              required:
                                                                                                _vm.$t(
                                                                                                  "forms.errors.fieldEmpty"
                                                                                                ),
                                                                                              zip: _vm.$t(
                                                                                                "forms.errors.zip"
                                                                                              ),
                                                                                            },
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "default",
                                                                                              fn: function (
                                                                                                ref
                                                                                              ) {
                                                                                                var errors =
                                                                                                  ref.errors
                                                                                                var invalid =
                                                                                                  ref.invalid
                                                                                                return [
                                                                                                  _c(
                                                                                                    "FormInputZip",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          placeholder:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.zip"
                                                                                                            ),
                                                                                                          label:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.zip"
                                                                                                            ),
                                                                                                          name: "zip",
                                                                                                          error:
                                                                                                            errors.length >
                                                                                                            0,
                                                                                                          required:
                                                                                                            _vm.isDelivery,
                                                                                                          disabled:
                                                                                                            _vm.formLocked,
                                                                                                        },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            _vm
                                                                                                              .form
                                                                                                              .billingAddress
                                                                                                              .postcode,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                _vm
                                                                                                                  .form
                                                                                                                  .billingAddress,
                                                                                                                "postcode",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "form.billingAddress.postcode",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                  _vm._v(
                                                                                    " "
                                                                                  ),
                                                                                  _c(
                                                                                    "ValidationProvider",
                                                                                    {
                                                                                      staticClass:
                                                                                        "form-group__span--8 form-group__span--xxl-9",
                                                                                      attrs:
                                                                                        {
                                                                                          name: "billingCity",
                                                                                          rules:
                                                                                            "required",
                                                                                          tag: "div",
                                                                                          customMessages:
                                                                                            {
                                                                                              required:
                                                                                                _vm.$t(
                                                                                                  "forms.errors.fieldEmpty"
                                                                                                ),
                                                                                            },
                                                                                        },
                                                                                      scopedSlots:
                                                                                        _vm._u(
                                                                                          [
                                                                                            {
                                                                                              key: "default",
                                                                                              fn: function (
                                                                                                ref
                                                                                              ) {
                                                                                                var errors =
                                                                                                  ref.errors
                                                                                                var invalid =
                                                                                                  ref.invalid
                                                                                                return [
                                                                                                  _c(
                                                                                                    "FormInput",
                                                                                                    {
                                                                                                      attrs:
                                                                                                        {
                                                                                                          type: "text",
                                                                                                          placeholder:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.city"
                                                                                                            ),
                                                                                                          label:
                                                                                                            _vm.$t(
                                                                                                              "forms.labels.city"
                                                                                                            ),
                                                                                                          name: "city",
                                                                                                          error:
                                                                                                            errors.length >
                                                                                                            0,
                                                                                                          required:
                                                                                                            "",
                                                                                                          disabled:
                                                                                                            _vm.formLocked,
                                                                                                        },
                                                                                                      model:
                                                                                                        {
                                                                                                          value:
                                                                                                            _vm
                                                                                                              .form
                                                                                                              .billingAddress
                                                                                                              .city,
                                                                                                          callback:
                                                                                                            function (
                                                                                                              $$v
                                                                                                            ) {
                                                                                                              _vm.$set(
                                                                                                                _vm
                                                                                                                  .form
                                                                                                                  .billingAddress,
                                                                                                                "city",
                                                                                                                $$v
                                                                                                              )
                                                                                                            },
                                                                                                          expression:
                                                                                                            "form.billingAddress.city",
                                                                                                        },
                                                                                                    }
                                                                                                  ),
                                                                                                ]
                                                                                              },
                                                                                            },
                                                                                          ],
                                                                                          null,
                                                                                          true
                                                                                        ),
                                                                                    }
                                                                                  ),
                                                                                ],
                                                                                1
                                                                              ),
                                                                              _vm._v(
                                                                                " "
                                                                              ),
                                                                              invalid &&
                                                                              (validated ||
                                                                                dirty)
                                                                                ? _c(
                                                                                    "div",
                                                                                    {
                                                                                      staticClass:
                                                                                        "form-input__error | form-input-error form-group__span--12",
                                                                                      domProps:
                                                                                        {
                                                                                          innerHTML:
                                                                                            _vm._s(
                                                                                              Object.values(
                                                                                                errors
                                                                                              )
                                                                                                .filter(
                                                                                                  function (
                                                                                                    value
                                                                                                  ) {
                                                                                                    return !!value
                                                                                                      .join(
                                                                                                        ""
                                                                                                      )
                                                                                                      .trim()
                                                                                                  }
                                                                                                )
                                                                                                .join(
                                                                                                  " "
                                                                                                )
                                                                                            ),
                                                                                        },
                                                                                    }
                                                                                  )
                                                                                : _vm._e(),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-row",
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "form-row__wrapper",
                                                                },
                                                                [
                                                                  _c(
                                                                    "FormInput",
                                                                    {
                                                                      attrs: {
                                                                        type: "text",
                                                                        placeholder:
                                                                          _vm.$t(
                                                                            "forms.labels.addressDetails"
                                                                          ),
                                                                        label:
                                                                          _vm.$t(
                                                                            "forms.labels.addressDetails"
                                                                          ),
                                                                        labelOption:
                                                                          _vm.$t(
                                                                            "forms.labels.optional"
                                                                          ),
                                                                        name: "addressdetails",
                                                                        required: false,
                                                                        hint: _vm.$t(
                                                                          "forms.labels.courierHint"
                                                                        ),
                                                                        disabled:
                                                                          _vm.formLocked,
                                                                      },
                                                                      model: {
                                                                        value:
                                                                          _vm
                                                                            .form
                                                                            .billingAddress
                                                                            .details,
                                                                        callback:
                                                                          function (
                                                                            $$v
                                                                          ) {
                                                                            _vm.$set(
                                                                              _vm
                                                                                .form
                                                                                .billingAddress,
                                                                              "details",
                                                                              $$v
                                                                            )
                                                                          },
                                                                        expression:
                                                                          "form.billingAddress.details",
                                                                      },
                                                                    }
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                              _vm._v(" "),
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  staticClass:
                                                                    "form-row__wrapper",
                                                                  attrs: {
                                                                    name: "billingCountry",
                                                                    rules:
                                                                      "required",
                                                                    tag: "div",
                                                                    customMessages:
                                                                      {
                                                                        required:
                                                                          _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          ),
                                                                      },
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function (
                                                                            ref
                                                                          ) {
                                                                            var errors =
                                                                              ref.errors
                                                                            var invalid =
                                                                              ref.invalid
                                                                            return [
                                                                              _c(
                                                                                "FormInputSelect",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      options:
                                                                                        _vm.countryOptions,
                                                                                      label:
                                                                                        _vm.$t(
                                                                                          "forms.labels.country"
                                                                                        ),
                                                                                      name: "country",
                                                                                      disabled:
                                                                                        _vm.formLocked,
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .countryCode,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .form
                                                                                              .billingAddress,
                                                                                            "countryCode",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "form.billingAddress.countryCode",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                          _vm._v(" "),
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "form-row",
                                                            },
                                                            [
                                                              _c(
                                                                "ValidationProvider",
                                                                {
                                                                  staticClass:
                                                                    "form-row__wrapper",
                                                                  attrs: {
                                                                    name: "billingPhone",
                                                                    rules:
                                                                      "required|phone_int",
                                                                    tag: "div",
                                                                    customMessages:
                                                                      {
                                                                        required:
                                                                          _vm.$t(
                                                                            "forms.errors.fieldEmpty"
                                                                          ),
                                                                        phone_int:
                                                                          _vm.$t(
                                                                            "forms.errors.phone"
                                                                          ),
                                                                      },
                                                                  },
                                                                  scopedSlots:
                                                                    _vm._u(
                                                                      [
                                                                        {
                                                                          key: "default",
                                                                          fn: function (
                                                                            ref
                                                                          ) {
                                                                            var errors =
                                                                              ref.errors
                                                                            var invalid =
                                                                              ref.invalid
                                                                            var validated =
                                                                              ref.validated
                                                                            return [
                                                                              _c(
                                                                                "FormInput",
                                                                                {
                                                                                  attrs:
                                                                                    {
                                                                                      type: "tel",
                                                                                      placeholder:
                                                                                        _vm.$t(
                                                                                          "forms.labels.phone"
                                                                                        ),
                                                                                      label:
                                                                                        _vm.$t(
                                                                                          "forms.labels.phone"
                                                                                        ),
                                                                                      name: "phone",
                                                                                      error:
                                                                                        errors.length >
                                                                                        0,
                                                                                      "error-message":
                                                                                        errors[0],
                                                                                      hint: _vm.$t(
                                                                                        "checkout.phoneHint"
                                                                                      ),
                                                                                      disabled:
                                                                                        _vm.formLocked,
                                                                                      required:
                                                                                        "",
                                                                                    },
                                                                                  model:
                                                                                    {
                                                                                      value:
                                                                                        _vm
                                                                                          .form
                                                                                          .billingAddress
                                                                                          .phoneNumber,
                                                                                      callback:
                                                                                        function (
                                                                                          $$v
                                                                                        ) {
                                                                                          _vm.$set(
                                                                                            _vm
                                                                                              .form
                                                                                              .billingAddress,
                                                                                            "phoneNumber",
                                                                                            $$v
                                                                                          )
                                                                                        },
                                                                                      expression:
                                                                                        "form.billingAddress.phoneNumber",
                                                                                    },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          },
                                                                        },
                                                                      ],
                                                                      null,
                                                                      true
                                                                    ),
                                                                }
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            : _vm._e(),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.showTipInput
                                    ? _c("div", [
                                        _c("h2", {
                                          staticClass:
                                            "checkout-form__block-title",
                                          domProps: {
                                            innerHTML: _vm._s(
                                              _vm.$t("checkout.tipTitle")
                                            ),
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("div", { staticClass: "form-row" }, [
                                          _c(
                                            "div",
                                            {
                                              staticClass: "form-row__wrapper",
                                            },
                                            [
                                              _c("FormInputRange", {
                                                attrs: {
                                                  min: 0,
                                                  max: 5000,
                                                  step: 50,
                                                  displayValue:
                                                    _vm.$options.filters.madpricecent(
                                                      _vm.tip,
                                                      "short"
                                                    ),
                                                  prefix: _vm.themeValue(
                                                    "THEME_CURRENCY_PREFIX"
                                                  ),
                                                  disabled: _vm.formLocked,
                                                },
                                                model: {
                                                  value: _vm.tip,
                                                  callback: function ($$v) {
                                                    _vm.tip = _vm._n($$v)
                                                  },
                                                  expression: "tip",
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ]),
                                      ])
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "checkout-form__block" },
                                    [
                                      _c("h2", {
                                        staticClass:
                                          "checkout-form__block-title",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            _vm.$t("checkout.couponTitle")
                                          ),
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "form-row" }, [
                                        _c(
                                          "div",
                                          { staticClass: "form-row__wrapper" },
                                          [
                                            _c("ValidationProvider", {
                                              ref: "couponCode",
                                              attrs: {
                                                rules: { regex: /.{3,40}/ },
                                                name: "couponCode",
                                                tag: "div",
                                                customMessages: {
                                                  regex: _vm.$t(
                                                    "forms.errors.format"
                                                  ),
                                                },
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "default",
                                                    fn: function (ref) {
                                                      var invalid = ref.invalid
                                                      var errors = ref.errors
                                                      var validated =
                                                        ref.validated
                                                      return [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "form-combo form-combo--input-button",
                                                          },
                                                          [
                                                            _c("FormInput", {
                                                              attrs: {
                                                                label: _vm.$t(
                                                                  "checkout.couponLabel"
                                                                ),
                                                                placeholder:
                                                                  _vm.$t(
                                                                    "checkout.couponLabel"
                                                                  ),
                                                                disabled:
                                                                  _vm.formLocked,
                                                              },
                                                              on: {
                                                                keydown:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    if (
                                                                      !$event.type.indexOf(
                                                                        "key"
                                                                      ) &&
                                                                      _vm._k(
                                                                        $event.keyCode,
                                                                        "enter",
                                                                        13,
                                                                        $event.key,
                                                                        "Enter"
                                                                      )
                                                                    ) {
                                                                      return null
                                                                    }
                                                                    $event.preventDefault()
                                                                    return _vm.addCoupon.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.couponCode,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.couponCode =
                                                                      $$v
                                                                  },
                                                                expression:
                                                                  "couponCode",
                                                              },
                                                            }),
                                                            _vm._v(" "),
                                                            _c("Button", {
                                                              attrs: {
                                                                type: "button",
                                                                level:
                                                                  "secondary",
                                                                text: _vm.$t(
                                                                  "checkout.couponButton"
                                                                ),
                                                                variants: [
                                                                  "small",
                                                                ],
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    $event.preventDefault()
                                                                    return _vm.addCoupon.apply(
                                                                      null,
                                                                      arguments
                                                                    )
                                                                  },
                                                              },
                                                            }),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _vm.$te(
                                                          "checkout.couponHint"
                                                        )
                                                          ? _c("span", {
                                                              staticClass:
                                                                "form-input__hint | form-input-hint",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.$t(
                                                                      "checkout.couponHint"
                                                                    )
                                                                  ),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        errors.length > 0 &&
                                                        errors[0]
                                                          ? _c("span", {
                                                              staticClass:
                                                                "form-input__error | form-input-error",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    errors[0]
                                                                  ),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        !!_vm.couponSuccess
                                                          ? _c("span", {
                                                              staticClass:
                                                                "form-input__success | form-input-success",
                                                              domProps: {
                                                                innerHTML:
                                                                  _vm._s(
                                                                    _vm.couponSuccess
                                                                  ),
                                                              },
                                                            })
                                                          : _vm._e(),
                                                      ]
                                                    },
                                                  },
                                                ],
                                                null,
                                                true
                                              ),
                                            }),
                                          ],
                                          1
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _vm.accountCoupons.length
                                        ? _c(
                                            "div",
                                            { staticClass: "form-row" },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "form-row__wrapper checkout-form__coupons",
                                                },
                                                [
                                                  _c("span", {
                                                    domProps: {
                                                      innerHTML: _vm._s(
                                                        _vm.$t(
                                                          "checkout.couponUserTitle"
                                                        )
                                                      ),
                                                    },
                                                  }),
                                                  _vm._v(" "),
                                                  _c("FormInputSelect", {
                                                    staticClass:
                                                      "checkout-form__coupons-select",
                                                    attrs: {
                                                      options:
                                                        _vm.accountCouponsEnhanced,
                                                      label: _vm.$t(
                                                        "checkout.couponUserLabel"
                                                      ),
                                                      disabled: _vm.formLocked,
                                                    },
                                                    on: {
                                                      input:
                                                        _vm.onCouponCodeSelect,
                                                    },
                                                  }),
                                                ],
                                                1
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "checkout-form__block" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "accept" },
                                        [
                                          _c(
                                            "FormInputCheckbox",
                                            {
                                              attrs: {
                                                name: "newsletter",
                                                value: "newsletter",
                                                immediate: "",
                                                disabled: _vm.formLocked,
                                              },
                                              model: {
                                                value: _vm.form.newsletter,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "newsletter",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.newsletter",
                                              },
                                            },
                                            [
                                              _c("span", {
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.$t(
                                                      "checkout.newsletterLabel"
                                                    )
                                                  ),
                                                },
                                              }),
                                            ]
                                          ),
                                          _vm._v(" "),
                                          _vm.cartIncludesAlcohol
                                            ? _c("ValidationProvider", {
                                                attrs: {
                                                  rules: {
                                                    required: {
                                                      allowFalse: false,
                                                    },
                                                  },
                                                  name: "checkAlcohol",
                                                  tag: "div",
                                                  customMessages: {
                                                    required: _vm.$t(
                                                      "checkout.errorAlcohol"
                                                    ),
                                                  },
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "default",
                                                      fn: function (ref) {
                                                        var invalid =
                                                          ref.invalid
                                                        var errors = ref.errors
                                                        var validated =
                                                          ref.validated
                                                        return [
                                                          _c(
                                                            "FormInputCheckbox",
                                                            {
                                                              attrs: {
                                                                name: "alcohol",
                                                                value:
                                                                  "checkAlcohol",
                                                                error:
                                                                  errors.length >
                                                                  0,
                                                                "error-message":
                                                                  errors[0],
                                                                required: "",
                                                                immediate: "",
                                                                disabled:
                                                                  _vm.formLocked,
                                                              },
                                                              model: {
                                                                value:
                                                                  _vm.form
                                                                    .checkAlcohol,
                                                                callback:
                                                                  function (
                                                                    $$v
                                                                  ) {
                                                                    _vm.$set(
                                                                      _vm.form,
                                                                      "checkAlcohol",
                                                                      $$v
                                                                    )
                                                                  },
                                                                expression:
                                                                  "form.checkAlcohol",
                                                              },
                                                            },
                                                            [
                                                              _c("span", {
                                                                domProps: {
                                                                  innerHTML:
                                                                    _vm._s(
                                                                      _vm.$t(
                                                                        "checkout.alcoholLabel"
                                                                      )
                                                                    ),
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      },
                                                    },
                                                  ],
                                                  null,
                                                  true
                                                ),
                                              })
                                            : _vm._e(),
                                          _vm._v(" "),
                                          _c("ValidationProvider", {
                                            attrs: {
                                              rules: {
                                                required: { allowFalse: false },
                                              },
                                              name: "checkAgb",
                                              tag: "div",
                                              customMessages: {
                                                required: _vm.$t(
                                                  "checkout.errorTerms"
                                                ),
                                              },
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "default",
                                                  fn: function (ref) {
                                                    var invalid = ref.invalid
                                                    var errors = ref.errors
                                                    var validated =
                                                      ref.validated
                                                    return [
                                                      _c(
                                                        "FormInputCheckbox",
                                                        {
                                                          attrs: {
                                                            name: "terms",
                                                            value: "checkAgb",
                                                            error:
                                                              errors.length > 0,
                                                            "error-message":
                                                              errors[0],
                                                            required: "",
                                                            immediate: "",
                                                            disabled:
                                                              _vm.formLocked,
                                                          },
                                                          model: {
                                                            value:
                                                              _vm.form.checkAgb,
                                                            callback: function (
                                                              $$v
                                                            ) {
                                                              _vm.$set(
                                                                _vm.form,
                                                                "checkAgb",
                                                                $$v
                                                              )
                                                            },
                                                            expression:
                                                              "form.checkAgb",
                                                          },
                                                        },
                                                        [
                                                          _c("span", {
                                                            domProps: {
                                                              innerHTML: _vm._s(
                                                                _vm.$t(
                                                                  "checkout.termsLabel"
                                                                )
                                                              ),
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  },
                                                },
                                              ],
                                              null,
                                              true
                                            ),
                                          }),
                                          _vm._v(" "),
                                          _c("Button", {
                                            attrs: {
                                              type: "button",
                                              level: "primary",
                                              text: _vm.$t(
                                                "checkout.orderButton"
                                              ),
                                              disabled: _vm.formLocked,
                                            },
                                            on: { click: _vm.onSubmit },
                                          }),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            [
                                              _c("Button", {
                                                staticClass:
                                                  "checkout-form__back-to-shop checkout-form__back-to-shop--bottom",
                                                attrs: {
                                                  level: "tertiary",
                                                  type: "button",
                                                  text: _vm.$t(
                                                    "checkout.continueShopping"
                                                  ),
                                                  arrow: "",
                                                  reverse: "",
                                                  disabled: _vm.formLocked,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    $event.preventDefault()
                                                    return _vm.backToShop.apply(
                                                      null,
                                                      arguments
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          ),
                                        ],
                                        1
                                      ),
                                    ]
                                  ),
                                ]
                              },
                            },
                          ]),
                        }),
                      ],
                ],
          ],
          2
        ),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass:
          "checkout-form__cart-placeholder insicht insicht--fade-in insicht--fast",
      },
      [
        _c("OverlaySidebarCart", {
          ref: "sidebarCart",
          attrs: { "is-editable": false, "is-inline": true },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }